// taken from here: https://stackoverflow.com/questions/521295/seeding-the-random-number-generator-in-javascript#:~:text=a%20performance%20hit.-,Mulberry32,-Mulberry32%20is%20a
// receives an integer seed and returns a random number between 0 and 1
export default function randomFromSeed(seed: number) {
  var t = (seed += 0x6d2b79f5);
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
}
